import React, { useRef, useState } from 'react'
import { Form, App, Input, Modal } from 'antd';
import { useBnsGongNengAddMutation } from '../../store/BnsKeJiApi';
import { PlusSquareOutlined } from '@ant-design/icons';

const { TextArea } = Input;

function ModuleAdd(props) {
    const { message } = App.useApp();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [info, setInfo] = useState({
        "bgn_content": '',
        "bgn_image": '',
        "bgn_luyou": '',
        "bgn_state": '',
        "bgn_goods": '',
        "bgn_price": '',
        bgn_bg_id: props.bg_id,
        bgn_dept_id: '540',
        bgn_dept_name: '开发部'
    });
    
    const [add] = useBnsGongNengAddMutation();
    const editForm = useRef();
    const handleOk = () => {
        form.validateFields().then(values => {
            add({
                "bgn_bg_id": info.bgn_bg_id,
                "bgn_cid": localStorage.getItem('eu_id'),
                "bgn_cname": localStorage.getItem('eu_name'),
                "bgn_content": info.bgn_content,
                "bgn_dept_id": info.bgn_dept_id,
                "bgn_dept_name": info.bgn_dept_name,
                "bgn_e_id": localStorage.getItem('e_id'),
                "bgn_name": info.bgn_name,
                "bgn_image": info.bgn_image,
                "bgn_luyou": info.bgn_luyou,
                "bgn_state": info.bgn_state,
                "bgn_goods": info.bgn_goods,
                "bgn_price": info.bgn_price,
            }).then((res) => {
                if (res.data.Status === 'success') {
                    message.info('新增成功！');
                    setOpen(false);
                    form.resetFields();
                } else if (res.data.Status === "fail") {
                    message.error('新增失败！' + res.data.Message);
                }
            });
        }).catch(error => {
            console.error('表单验证失败:', error);
        });
    };

    return (
        <>
            <a onClick={() => { setOpen(true) }}><PlusSquareOutlined /> 新增模块</a>
            <Modal
                open={open}
                width={800}
                title={props.bg_name + "- 新增模块"}
                onCancel={() => { setOpen(false); form.resetFields(); }}
                onOk={handleOk}
                
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_client_add"
                    initialValues={{ modifier: 'public' }}
                    labelCol={{ span: 3 }}
                    wrapperCol={{ span: 11 }}
                    ref={editForm}
                >
                    <Form.Item
                        name="bgn_name"
                        label="模块名称"
                        wrapperCol={{ span: 10 }}
                        rules={[{ required: true, message: '请输入模块名称' }]}
                    >
                        <Input
                            onChange={(e) => { setInfo(prevState => ({ ...prevState, bgn_name: e.target.value })) }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="bgn_content"
                        label="备注"
                        wrapperCol={{ span: 20 }}
                    >
                        <TextArea
                            onChange={(e) => {
                                setInfo(prevState => ({ ...prevState, bgn_content: e.target.value }))
                            }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModuleAdd;